export default __webpack_public_path__ + "static/media/loading-logo.ddf1ffc5.gif";